import * as React from "react";
import { useEffect } from "react";
import axios from "axios";
import socketIOClient from "socket.io-client";

import "./App.css";

import GameContainer from "./GameContainer";
import StartScreen from "./StartScreen";
import GameRule from "./Types/GameRule";
import Game from "./Types/Game";

import { useSocketListener } from "./useSocketListener";

import * as api from "./Api";
import { GameSound } from "./Hooks/useGameSound";
import SoundIcon from "./SoundIcon";
import Statistics from "./Statistics";

// @ts-ignore
const socket = socketIOClient({ path: window.REACT_APP_SOCKET_URL });

const App = () => {
  const [showStatistics, setShowStatistics] = React.useState(false);
  const [game, setGame] = React.useState<Game | undefined>(undefined);
  const [isSpectating, setIsSpectating] = React.useState(false);
  const [games, setGames] = React.useState<Game[]>([]);
  const [joinAsExistingName, setJoinAsExistingName] = React.useState<
    string | undefined
  >(undefined);

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(`${api.apiUrl}/games`);

      setGames(result.data);
    };

    fetchData();
  }, []);

    useEffect(() => {
      api.logVisitor()
    }, []);

  const onLeaveGame = (game: Game, name: string) => {
    api.leaveGame(game, name);

    setGame(undefined);
  };

  const onGameRulesChange = (game: Game, rules: GameRule) => {
    api.setGameRules(game, rules);
  };

  const onTimeLimitChange = (game: Game, isTimeLimitEnabled: boolean) => {
    api.setTimeLimit(game, isTimeLimitEnabled);
  };

  const onStartGame = (game: Game) => {
    api.startGame(game);
  };
  // const onSpectateGame = (game: Game) => {
  //   api.spectateGame(game, socket.id);
  // };
  const onRemovePlayer = (game: Game, name: string) => {
    api.leaveGame(game, name);
  };

  useSocketListener("games", socket, (games: Game[]) => {
    setGames(games);

    if (game) {
      const updatedGame = games.find((g) => g.id === game.id);

      if (updatedGame && updatedGame.state !== "cancelled") {
        setGame(updatedGame);
      } else {
        setGame(undefined);
      }
    }
  });

  if (showStatistics) {
    return <Statistics onBack={() => setShowStatistics(false)} />;
  }

  return (
    <GameSound>
      <SoundIcon />

      {game && game.state !== "cancelled" ? (
        <GameContainer
          game={game}
          joinAsName={joinAsExistingName}
          socket={socket}
          onLeave={onLeaveGame}
          onStart={onStartGame}
          onGameRulesChange={onGameRulesChange}
          onTimeLimitChange={onTimeLimitChange}
          onRemovePlayer={onRemovePlayer}
          isSpectating={isSpectating}
        />
      ) : (
        <StartScreen
          games={games}
          onCreateGame={() => api.createGame()}
          onJoinGame={(game, name) => {
            console.log("onJoinGame", game);

            if (name) {
              setJoinAsExistingName(name);
            }
            if (game) {
              setGame(games.find((g) => g.id === game.id));
            }
          }}
          onShowStatistics={() => setShowStatistics(true)}
          onSpectateGame={(game) => {
            console.log("onSpectateGame", game);
            setIsSpectating(true);
            if (game) {
              setGame(games.find((g) => g.id === game.id));
            }
          }}
        />
      )}
    </GameSound>
  );
};

export default App;
